import { Box } from '@mui/material'
import { phone } from '../../images'
import { messages } from '../../constants'
import { Message, Notification } from '../molecules'

const Phone = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      width='100%'
      minHeight='100%'
      position='relative'
      p='70px 35px 0 30px'
      sx={{
        '@media (max-width: 1280px)': {
          pt: '60px'
        },
        '@media (max-width: 768px)': {
          p: '50px 25px 0 25px'
        },
        '@media (max-width: 638px)': {
          pt: '90px',
          px: '40px'
        },
        '@media (max-width: 530px)': {
          pt: '70px',
          px: '35px'
        },
        '@media (max-width: 450px)': {
          pt: '60px',
          px: '25px'
        },
        '@media (max-width: 390px)': {
          pt: '50px'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: 'calc(100% + 80px)',
          backgroundImage: `url(${phone.default.src})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          top: 0,
          left: 0
        }
      }}
      gridArea='phone'>
      <Box
        display='flex'
        flexDirection='column'
        width='100%'
        gap='5px'
        zIndex={1}
        sx={{
          '@media (max-width: 1280px)': {
            gap: '4px'
          },
          '@media (max-width: 768px)': {
            gap: '8px'
          },
          '@media (max-width: 638px)': {
            gap: '6px'
          },
          '@media (max-width: 480px)': {
            gap: '4px'
          }
        }}>
        {messages.map((message, index) => (
          <Message
            isIncoming={index % 2 !== 0}
            avatarSrc={message.avatarSrc}
            text={message.text}
            key={message.id}
          />
        ))}
      </Box>
      <Notification />
    </Box>
  )
}

export default Phone
